import React from "react";

import TxnNetsSuccessStatusLayout from "./txn_nets_success_status_layout";

const TxnNetsSuccessStatusPage = () => {
  return (
    <>
      <TxnNetsSuccessStatusLayout />
    </>
  );
};

export default TxnNetsSuccessStatusPage;